import { render, staticRenderFns } from "./RedBatch.vue?vue&type=template&id=798d31af&scoped=true&"
import script from "./RedBatch.vue?vue&type=script&lang=ts&"
export * from "./RedBatch.vue?vue&type=script&lang=ts&"
import style0 from "./RedBatch.vue?vue&type=style&index=0&id=798d31af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798d31af",
  null
  
)

export default component.exports